import React, {Component} from 'react'
import Link from 'gatsby-link'
import styled, {keyframes} from "styled-components";
import {auth, db, firebase} from '../firebase';
import colors from '../styles/colors';
import {NotificationContainer, NotificationManager} from "react-notifications";
import {
    AppContainer,
    Header,
    Heading,
    Body,
    MainAction,
    CreateAppContainer,
    ImageUploadClinicSection
} from '../Components/AppChrome';
import {SearchBox, SearchHits, SearchHit} from '../Components/Search';
import en from '../locales/en/translation.json';
import spn from '../locales/sp/translation.json';
import swe from '../locales/sw/translation.json'
import {
    RedLargeButton,
    GreenLargeButton,
    GreenButton,
    LogoutButton,
    DisabledButton,
    BlueButton
} from '../Components/Button';
import body from "../images/body2.svg";
import optimumLogo from "../images/optimum.png";
import googleSignIn from "../images/btn_google_signin_light_normal_web@2x.png";
import previous from '../images/back.svg';
import edit from '../images/edit.svg';
import {ImageInput} from './new'
import {storage} from "../firebase/firebase";


const NoFoundText = styled.div`
width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 1rem;
  text-align:center;
  font-weight: 500;
  color: ${colors.dark};
  line-height: 1.3;
  margin-top:230px
`;

const MailSpan = styled.span`
 font-size: 1rem;
 font-weight: 500;
 color:${colors.first}
`;

const OptimumLogo = styled.div`
  background: url(${optimumLogo}) no-repeat;
  background-position: center;
  background-size: 25rem;
  width: 100%;
  height: 60%;
`;

const keyFrameExampleOne = keyframes`
  0% { opacity: 0; }
  10% { opacity: 1; }
  75% { opacity: 1; }
  100% { opacity: 0; }
`;

const OptimumLogoFadeInOut = styled.div`
  background: url(${optimumLogo}) no-repeat;
  background-position: center;
  background-size: 25rem;
  width: 100%;
  height: 60%;
  opacity: 0;
  animation: ${keyFrameExampleOne} 3s ease-in-out 0s 1;
`;

// const ProfileImage = styled.img`
//   display: inline-block;
//   width: 2.5rem;
//   height: 2.5rem;
//   border-radius: 50%;
//   object-fit: cover;
//   margin: 10px;
// `;

const Info = styled.div`
  padding: 1rem;
`;

const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AdditionalInput = styled.input`;
  width: 1000%;
  height: 15px
  background-color: white;
  padding: 0.5rem 1rem 0.5rem 2.5rem;
  font-size: 1rem;
  border-radius: 2px;
  margin-bottom: 5px;
  margin-top: 20px;
  border: 2px solid ${colors.light};
  outline: none;
    &::placeholder {
    color: ${colors.light};
  }
`;

const Note = styled.div`
margin-top:20px;
text-align:center;
font-size:15px;
color:red;
`
const ContactText = styled.div`
text-align:center;
margin-top:20px;
font-size: 25px;
`;
const UploadClinicText = styled.div`
font-size: 20px;
margin-bottom:15px;
`
const Input = styled.input`
  width: 100%;
  height: 1rem;
  background-color: white;
  padding: 0.5rem 1rem 0.5rem 2.5rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 2px solid ${props => props.onChange ? colors.first : colors.light};
  outline: none;
  color: ${props => props.onChange ? colors.dark : colors.light};
  margin-bottom: 10px;

  &::placeholder {
    color: ${colors.light};
  }
`;

const Flex = styled.div`
  display: flex;

`;

const AdditionalInputText = (props) => {
    return (
        <Flex>
            <AdditionalInput
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    )
};

const InputText = (props) => {
    return (
        <Flex>
            <Input
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};

const InputEmail = (props) => {
    return (
        <Flex>
            <Input
                type={"email"}
                value={props.value}
                onChange={props.onChange}
                tabIndex={0}
                placeholder={props.placeholder}
                autoFocus
            />
        </Flex>
    );
};

const ButtonImage = styled.img`
  display: inline-block;
  width: 191px;
  cursor:pointer;
`;
const ItemAction = styled.div`
  width:100%
  margin-top: -50px;
  margin-bottom:15px;
  background-color: ${colors.first};
  display: flex;
  justify-content: flex-end

`;
const ImageDivision = styled.div`
 display: flex;
 flex-direction: row;
 margin-top:20px;
 
 `
const Container = styled.div`
  width: 100%;
  

`;
const ParticularExercise = styled.img`
 height: 130px;
    width: 200px;
    margin-top: 15px;
    margin-bottom: 20px;
`;
//TODO: Move these to component - used in sortableList also
const IconButton = (props) => {
    return (
        <ItemIcon src={props.icon} alt="" onClick={props.onClick}/>
    );
};
const SetsAndReps = styled.div`
 display: flex;
 flex-direction: row;
 margin-top:15px;
 `
const ItemIcon = styled.img`
  height: 1.1rem; 
`;

class IndexPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            authenticating: false,
            authUser: null,
            allUsers: [],
            users: [],
            user: null,
            userId: '',
            practitioner: null,
            searchText: '',
            showUserMenu: false,
            showNewUser: false,
            showEditUser: false,
            usersHit: true,
            clinicImage: '',
            logoImage: '',
            progress: 0,
            logoProgress: 0,
            base64: '',
            base64logo: '',
            mainLanguage: '',
            allow: "true"

        };

        this.setSearchBoxRef = this.setSearchBoxRef.bind(this);
    }

    setSearchBoxRef(searchBoxRef) {
        this.searchBox = searchBoxRef;
    }

    onFocusSearchBox() {
        if (this.searchBox) {
            this.searchBox.focus();
        }
    }

    onSignIn = (event) => {
        console.log("Signing in");
        auth.doGoogleSignInWithRedirect();
        // auth.doFacebookSignInWithRedirect();
    };


    getVerification() {
        let mainLanguage = window.localStorage.getItem('language');
        let getAllow = window.localStorage.getItem('allow');
        console.log('getAllow===',getAllow);
        this.setState({
            mainLanguage: mainLanguage,
            allow: getAllow
        })
    }

    onSignOut = (event) => {
        console.log("Signing out");
        auth.doSignOut();
        this.setState({
            authenticating: false,
            authUser: null,
            allUsers: [],
            users: [],
            userId: '',
            user: null,
            searchText: '',
            showUserMenu: false,
            showEditUser: false,
        });
        window.localStorage.removeItem('allow');
        this.props.history.push({
            pathname: '/'
        })
    };

    onCancelImpersonating = event => {
        const user = this.state.allUsers.find(user => user && user.id === this.state.practitioner.id);
        if (!user) {
            return;
        }
        this.setState({
            user,
            userId: user.id,
            showUserMenu: false,
            searchText: ''
        });
        this.props.history.push({
            search: '?user=' + encodeURIComponent(user.id)
        });
        this.onFocusSearchBox();
    }

    onCancelUserMenu = event => {
        this.setState({
            showUserMenu: false,
            searchText: ''
        });
        this.onFocusSearchBox();
    };

    onChangeSearchText = event => {
        const searchText = event.target.value;
        var searchTerm = new RegExp(searchText, 'gi');
        const users = this.state.allUsers.filter(user => user.name.match(searchTerm));
        this.setState({
            showUserMenu: searchText.length > 0,
            showNewUser: false,
            searchText,
            users
        });
        window.scrollTo(0, 0);
    };

    onUserSelected = event => {
        this.state.users.filter(user => user.id === event.currentTarget.id).map(user => {
            this.setState({
                user,
                userId: user.id,
                showUserMenu: false,
                searchText: ''
            });
            this.props.history.push({
                search: '?user=' + encodeURIComponent(user.id)
            });
            this.onFocusSearchBox();
        });
    };

    onNewUser = event => {
        this.setState({
            showNewUser: true,
            displayName: this.state.searchText,
            searchText: ''
        });
    };

    onCancelNewUser = event => {
        this.setState({
            showNewUser: false,
            showUserMenu: false,
            searchText: ''
        });
        this.onFocusSearchBox();
    };

    onCreateNewUser = event => {
        const userId = this.state.email.toLowerCase();
        db.getOrCreateUser(this.state.practitioner, userId, this.state.displayName, this.state.clinicName,
            this.state.physicalAddress, this.state.emailAddress, this.state.phoneNumber)
            .then(user => {
                this.setState({
                    showNewUser: false,
                    showUserMenu: false,
                    displayName: '',
                    email: '',
                    searchText: '',
                    userId: userId,
                    user: user,
                    users: [],
                    allUsers: [...this.state.allUsers, user]
                });
                this.props.history.push({
                    search: `?user=${encodeURIComponent(userId)}`
                });

                this.onFocusSearchBox();
            })
            .catch(errorMessage => {
                console.log(errorMessage);
            })
    };

    onEditUser = event => {
        this.setState({
            showEditUser: true,
            displayName: this.state.user.name,
            email: this.state.user.id,
            clinicName: this.state.user.clinicName,
            physicalAddress: this.state.user.physicalAddress,
            pdfShowEmailAddress: this.state.user.pdfShowEmailAddress,
            phoneNumber: this.state.user.phoneNumber,
            searchText: '',
        })
    };

    onCancelEditUser = event => {
        this.setState({
            showEditUser: false,
            showUserMenu: false,
            searchText: '',
        });
        this.onFocusSearchBox();
    };

    onUpdateUser = event => {
        db.updateUser(this.state.practitioner, this.state.user.id, this.state.displayName, this.state.clinicName,
            this.state.physicalAddress, this.state.pdfShowEmailAddress, this.state.phoneNumber, this.state.clinicImage, this.state.logoImage, this.state.mainLanguage)
            .then(updatedUser => {
                const allUsers = this.state.allUsers.slice(0).map(user => {
                    if (user.id === updatedUser.id) {
                        user.name = updatedUser.name;
                    }
                    return user;
                });
                setTimeout(() => {
                    this.setState({
                        showEditUser: false,
                        showUserMenu: false,
                        email: '',
                        displayName: '',
                        searchText: '',
                        clinicName: '',
                        physicalAddress: '',
                        pdfShowEmailAddress: '',
                        phoneNumber: '',
                        user: updatedUser,
                        users: [],
                        allUsers
                    });
                }, 2000)


                // this.onFocusSearchBox();
            })
            .catch(errorMessage => {
                console.log(errorMessage);
            })
    };


    onDeleteUser = event => {
        db.deleteUser(this.state.practitioner, this.state.user.id)
            .then(deletedUser => {
                const allUsers = this.state.allUsers.filter(user => {
                    return user.id !== deletedUser.id
                });

                this.setState({
                    showEditUser: false,
                    showUserMenu: false,
                    email: '',
                    displayName: '',
                    searchText: '',
                    clinicName: '',
                    physicalAddress: '',
                    pdfShowEmailAddress: '',
                    phoneNumber: '',
                    user: null,
                    users: [],
                    allUsers
                }, () => {
                    this.onCancelImpersonating();
                });
            })
            .catch(errorMessage => {
                console.log(errorMessage);
            })
    };

    onChangeDisplayName = event => {
        this.setState({displayName: event.target.value});
    };

    onChangeEmail = event => {
        this.setState({email: event.target.value});
    };

    onKeypress = event => {
        switch (event.keyCode) {
            case 13:  //enter
                event.currentTarget.id = this.state.users.length > 0 ? this.state.users[0].id : this.onNewUser(event);
                this.onUserSelected(event);
                break;
            case 27:  //escape
                this.setState({
                    showUserMenu: false,
                    showNewUser: false,
                    searchText: ''
                });
                break;
        }
    };

    componentWillMount() {
        const self = this;
        const userId = this.getQueryStringParameters(this.props.location.search).user;
        self.setState({
            authenticating: true,
        });

        firebase.auth.onAuthStateChanged(user => {
            if (!user) {
                self.setState({authenticating: false});
                console.log("Not authenticated.");
                return;
            }

            self.setState({
                authUser: user,
                authenticating: false
            });
            db.getUser(userId || user.email)
                .then(user => {
                    self.setState({
                        user,
                        userId: user.id
                    });
                    this.props.history.push({
                        search: '?user=' + encodeURIComponent(user.id)
                    });
                })
                .catch(errorMessage => {
                    console.log(errorMessage);
                    db.getUser().then(user => {
                        self.setState({user});
                    });
                    this.props.history.push({
                        pathname: '/'
                    });
                });

            db.getPractitioner()
                .then(practitioner => {
                  self.setState({practitioner},()=>{
                  });
                  this.getVerification();
                    return practitioner;
                })
                .then(practitioner => {
                        return db.getUsers(practitioner);
                    }
                )
                .then(allUsers => {
                    self.setState({allUsers}, () => {
                        if (self.state.searchText.length > 0) {
                            self.onChangeSearchText({target: {value: self.state.searchText}});
                        }
                        console.log("Users loaded: ", allUsers.length);
                    })
                })
                .catch(errorMessage => {
                    console.log(errorMessage);
                });
        });
    }

    getQueryStringParameters = query => {
        return query
            ? (/^[?#]/.test(query) ? query.slice(1) : query)
                .split('&')
                .reduce((params, param) => {
                        let [key, value] = param.split('=');
                        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                        return params;
                    }, {}
                )
            : {}
    };
    onClinicChange = (event) => {
        this.setState({
            clinicName: event.target.value
        })
    };
    onPhysicalAddressChange = (event) => {
        this.setState({
            physicalAddress: event.target.value
        })
    };
    onEmailAddressChange = (event) => {
        this.setState({
            pdfShowEmailAddress: event.target.value
        })
    };
    onPhoneNumberChange = (event) => {
        // if(event.target.value.match(/^[0-9\b]+$/)){
        // }
        this.setState({
            phoneNumber: event.target.value
        })

    };

    clinicImageChange(event) {
        this.setState({
            clinicImage: event.target.files[0]
        }, () => {
            let reader = new FileReader();
            reader.readAsDataURL(this.state.clinicImage);
            reader.onloadend = () => {
                this.setState({
                    base64: reader.result
                })
            }
        })
    }

    onLogoChange(event) {
        this.setState({
            logoImage: event.target.files[0]
        }, () => {
            let reader = new FileReader();
            reader.readAsDataURL(this.state.logoImage);
            reader.onloadend = () => {
                this.setState({
                    base64logo: reader.result
                })
            }
        })
    }


    handleUploadClinicImage() {
        const {mainLanguage} = this.state;
        let image = this.state.clinicImage;
        const uploadTask = storage.ref(`ClinicImages/${image.name}`).put(image);
        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                this.state.progress = progress
            }, (error) => {
                console.log(error)
            }, () => {
                storage.ref('ClinicImages').child(image.name).getDownloadURL().then(url => {
                    url = this.state.base64
                    this.setState({
                        clinicImage: url
                    }, () => {
                        if (this.state.progress === 100) {
                            NotificationManager.success(mainLanguage === 'English' ? en.imageUploaded : mainLanguage === 'Spanish' ? spn.imageUploaded : swe.imageUploaded, '', 1000)
                        }
                    })
                })
            });
    }

    handleUploadLogo() {
        const {mainLanguage} = this.state;
        let logo = this.state.logoImage;
        const uploadTask = storage.ref(`logos/${logo.name}`).put(logo);
        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                this.state.logoProgress = progress
            }, (error) => {
                console.log(error)
            }, () => {
                storage.ref('logos').child(logo.name).getDownloadURL().then(url => {
                    url = this.state.base64logo
                    this.setState({
                        logoImage: url
                    }, () => {
                        if (this.state.logoProgress === 100) {
                            NotificationManager.success(mainLanguage === 'English' ? en.logoUploaded : mainLanguage === 'Spanish' ? spn.logoUploaded : swe.logoUploaded, '', 1000)
                        }
                    })
                })
            });
    }

    // encodeQueryStringParameters = obj => {
    //   return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
    // }

    renderLogin() {
        return (
            <AppContainer>
                <OptimumLogo/>
                <MainAction>
                    <ButtonImage src={googleSignIn} onClick={this.onSignIn}/>
                </MainAction>
            </AppContainer>
        );
    }

    renderAuthenticating() {
        return (
            <AppContainer>
                <OptimumLogoFadeInOut/>
                <MainAction/>
            </AppContainer>
        );
    }

    renderMain() {
        const {mainLanguage, allow} = this.state;
        return (
            <AppContainer>
                {allow === "false" ?
                    <>
                        <Header>
                            <Heading>
                                <Flex>
                                    <EllipsisText>&nbsp; {this.state.user ? this.state.user.name : '...'}</EllipsisText>
                                </Flex>
                            </Heading>
                            <ItemAction>
                                <>
                                    <LogoutButton onClick={this.onSignOut}>
                                        {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                                    </LogoutButton>
                                </>
                            </ItemAction>
                        </Header>
                        <Body>
                            <NoFoundText>
                                Din prenumeration har utgått, vänligen
                                maila <MailSpan>info@optimum-metoden.se</MailSpan> för hjälp med att återaktivera
                                generatorn
                            </NoFoundText>
                        </Body>
                    </> :
                    <>
                        <Header>
                            <Heading>
                                <Flex>
                                    {this.state.user && this.state.practitioner && this.state.user.id != this.state.practitioner.id ?
                                        <div><IconButton icon={previous} height={'1.1rem'}
                                                         onClick={this.onCancelImpersonating}/></div>
                                        :
                                        null
                                    }
                                    <EllipsisText>&nbsp; {this.state.user ? this.state.user.name : '...'}</EllipsisText>
                                    <div>&nbsp;<IconButton icon={edit} height={'1.1rem'} onClick={this.onEditUser}/>
                                    </div>
                                </Flex>

                            </Heading>
                            <ItemAction>
                                <>
                                    {/*<LanguageTranslator/>*/}
                                    <LogoutButton onClick={this.onSignOut}>
                                        {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                                    </LogoutButton>
                                </>
                            </ItemAction>
                            {/* <Heading><EllipsisText>{ this.state.user ? this.state.user.name : '...' }</EllipsisText></Heading> */}
                            <SearchBox setSearchBoxRef={this.setSearchBoxRef} value={this.state.searchText}
                                       onChange={this.onChangeSearchText}
                                       placeholder={mainLanguage === 'English' ? en.searchTextMain : mainLanguage === 'Spanish' ? spn.searchTextMain : swe.searchTextMain}/>
                        </Header>

                        <Body>
                            {/* <BodyImage /> */}
                        </Body>

                        <MainAction>
                            &nbsp;
                            <Link to={`/show?user=${encodeURIComponent(this.state.userId)}`}>
                                <GreenLargeButton>
                                    {mainLanguage === 'English' ? en.Program : mainLanguage === 'Spanish' ? spn.Program : swe.Program}
                                </GreenLargeButton>
                            </Link>
                        </MainAction>
                    </>}
            </AppContainer>
        );
    }

    renderUserMenu() {
        const {mainLanguage} = this.state
        return (
            <AppContainer>
                <Header>
                    <Heading>
                        <Flex>
                            <div><IconButton icon={previous} height={'1.1rem'} onClick={this.onCancelUserMenu}/></div>
                            <EllipsisText>&nbsp; {this.state.user ? this.state.user.name : '...'}</EllipsisText>

                        </Flex>
                    </Heading>
                    <ItemAction>
                        <LogoutButton onClick={this.onSignOut}>
                            {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                        </LogoutButton>
                    </ItemAction>
                    <SearchBox setSearchBoxRef={this.setSearchBoxRef} value={this.state.searchText}
                               onChange={this.onChangeSearchText} onArrowKeys={this.onKeypress}
                               placeholder={"Sök efter kund"}/>
                </Header>

                <Body>
                    <SearchHits hits={this.state.users}>
                        <SearchHit onClick={this.onUserSelected} usersHit={this.state.usersHit}/>
                    </SearchHits>
                    <SearchHit
                        onClick={this.onNewUser}
                        name={mainLanguage === 'English' ? en.nykund : mainLanguage === 'Spanish' ? spn.nykund : swe.nykund}
                        usersHit={this.state.usersHit}/>
                </Body>

                {/*<MainAction>*/}
                {/*  &nbsp;*/}
                {/*  <GreenLargeButton onClick={this.onSignOut}>Logga ut</GreenLargeButton>*/}
                {/*</MainAction>*/}
            </AppContainer>
        );
    }

    renderNewUser() {
        const {mainLanguage} = this.state;
        return (
            <AppContainer>
                <Header>
                    <Heading>
                        <Flex>
                            <div><IconButton icon={previous} height={'1.1rem'} onClick={this.onCancelNewUser}/></div>
                            <EllipsisText>&nbsp;
                                {mainLanguage === 'English' ? en.nykundHeader : mainLanguage === 'Spanish' ? spn.nykundHeader : swe.nykundHeader}
                            </EllipsisText>
                        </Flex>
                    </Heading>
                    <ItemAction>
                        <LogoutButton onClick={this.onSignOut}>
                            {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                        </LogoutButton>
                    </ItemAction>
                </Header>

                <Body>
                    <Info>
                        <InputText value={this.state.displayName} onChange={this.onChangeDisplayName}
                                   placeholder={'Gisela Holmqvist'}/>
                        <InputEmail value={this.state.email} onChange={this.onChangeEmail}
                                    placeholder={'gisela.holmqvist@gmail.com'}/>
                    </Info>
                </Body>

                <MainAction>
                    &nbsp;
                    <GreenLargeButton onClick={this.onCreateNewUser}>
                        {mainLanguage === 'English' ? en.skapa : mainLanguage === 'Spanish' ? spn.skapa : swe.skapa}
                    </GreenLargeButton>
                </MainAction>
            </AppContainer>
        );
    }

    renderEditUser() {
        const {mainLanguage} = this.state
        return (
            <CreateAppContainer>
                <Header>
                    <Heading>
                        <Flex>
                            <div><IconButton icon={previous} height={'1.1rem'} onClick={this.onCancelEditUser}/></div>
                            <EllipsisText>
                                &nbsp;
                                {mainLanguage === 'English' ? en.Redigerakonto : mainLanguage === 'Spanish' ? spn.Redigerakonto : swe.Redigerakonto}
                            </EllipsisText>

                        </Flex>
                    </Heading>
                    <ItemAction>
                        <LogoutButton onClick={this.onSignOut}>
                            {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                        </LogoutButton>
                    </ItemAction>
                </Header>

                <Body>
                    <Info>
                        <InputText value={this.state.displayName} onChange={this.onChangeDisplayName}
                                   placeholder={'Gisela Holmqvist'}/>
                        <InputEmail value={this.state.email} placeholder={'gisela.holmqvist@gmail.com'}/>
                        {(this.state.practitioner.id === this.state.userId) &&
                        <>
                            <Note>
                                {mainLanguage === 'English' ? en.Imagesizewarning : mainLanguage === 'Spanish' ? spn.Imagesizewarning : swe.Imagesizewarning}
                            </Note>
                            <ImageDivision>
                                <Container>
                                    <UploadClinicText>
                                        {mainLanguage === 'English' ? en.clinicImageText : mainLanguage === 'Spanish' ? spn.clinicImageText : swe.clinicImageText}
                                    </UploadClinicText>
                                    <ImageInput onChange={(event) => {
                                        this.clinicImageChange(event)
                                    }}/>
                                    <div style={{"margin-top": "10px"}}>
                                        <progress value={this.state.progress} max='100'/>
                                    </div>
                                    <ParticularExercise
                                        src={this.state.clinicImage || "http://via.placeholder.com/200x200"}
                                        alt='Uploaded Images'/>
                                    <div>
                                        {this.state.clinicImage === '' ?
                                            <DisabledButton>
                                                {mainLanguage === 'English' ? en.Upload : mainLanguage === 'Spanish' ? spn.Upload : swe.Upload}
                                            </DisabledButton> :
                                            <BlueButton onClick={() => {
                                                this.handleUploadClinicImage()
                                            }}>
                                                {mainLanguage === 'English' ? en.Upload : mainLanguage === 'Spanish' ? spn.Upload : swe.Upload}
                                            </BlueButton>}
                                    </div>
                                </Container>

                                <Container>
                                    <UploadClinicText>
                                        {mainLanguage === 'English' ? en.clinicLogoText : mainLanguage === 'Spanish' ? spn.clinicLogoText : swe.clinicLogoText}
                                    </UploadClinicText>
                                    <ImageInput onChange={(event) => {
                                        this.onLogoChange(event)
                                    }}/>
                                    <div style={{"margin-top": "10px"}}>
                                        <progress value={this.state.logoProgress} max='100'/>
                                    </div>
                                    <ParticularExercise
                                        src={this.state.logoImage || "http://via.placeholder.com/200x200"}
                                        alt='Uploaded Images'/>
                                    <div>
                                        {this.state.logoImage === '' ?
                                            <DisabledButton>
                                                {mainLanguage === 'English' ? en.Upload : mainLanguage === 'Spanish' ? spn.Upload : swe.Upload}
                                            </DisabledButton> :
                                            <BlueButton onClick={() => {
                                                this.handleUploadLogo()
                                            }}>
                                                {mainLanguage === 'English' ? en.Upload : mainLanguage === 'Spanish' ? spn.Upload : swe.Upload}
                                            </BlueButton>}
                                    </div>
                                </Container>
                            </ImageDivision>
                        </>}
                        <ContactText>
                            {mainLanguage === 'English' ? en.Contactinfo : mainLanguage === 'Spanish' ? spn.Contactinfo : swe.Contactinfo}

                        </ContactText>
                        <AdditionalInputText value={this.state.clinicName} onChange={this.onClinicChange}
                                             placeholder={'Clinic Name'}/>
                        <AdditionalInputText value={this.state.physicalAddress} onChange={this.onPhysicalAddressChange}
                                             placeholder={'Physical address'}/>
                        <AdditionalInputText value={this.state.pdfShowEmailAddress} onChange={this.onEmailAddressChange}
                                             placeholder={'Email'}/>
                        <AdditionalInputText value={this.state.phoneNumber} onChange={this.onPhoneNumberChange}
                                             placeholder={'Phone Number'}/>
                    </Info>
                </Body>

                <ImageUploadClinicSection>
                    <RedLargeButton onClick={this.onDeleteUser}>
                        {mainLanguage === 'English' ? en.Radera : mainLanguage === 'Spanish' ? spn.Radera : swe.Radera}

                    </RedLargeButton>
                    <GreenLargeButton onClick={this.onUpdateUser}>
                        {mainLanguage === 'English' ? en.Spara : mainLanguage === 'Spanish' ? spn.Spara : swe.Spara}
                    </GreenLargeButton>
                </ImageUploadClinicSection>
                <NotificationContainer/>
            </CreateAppContainer>
        );
    }

    render() {
        if (this.state.authenticating) {
            return this.renderAuthenticating();
        }

        if (this.state.showNewUser) {
            return this.renderNewUser();
        }

        if (this.state.showEditUser) {
            return this.renderEditUser();
        }

        if (this.state.showUserMenu) {
            return this.renderUserMenu();
        }

        if (this.state.authUser) {
            return this.renderMain();
        }

        return this.renderLogin();
    }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js